// extracted by mini-css-extract-plugin
export default {"hotel-access-cta":"components-settings-hotel-access-tables-cells-cell-cta-module__hotel-access-cta"};